import { InMemoryCache } from '@apollo/client';
import possibleTypes from '@atlassian/mpac-types/dist/GraphQLGateway.possibleTypes.gen.json';
export const createApolloCache = initialState => {
  const cache = new InMemoryCache({
    possibleTypes,
    typePolicies: {
      // Workaround for this apollo bug: https://github.com/apollographql/apollo-client/issues/7636
      // by disabling caching for this field (https://bit.ly/371l02H)
      CompatibleAtlassianProduct: {
        keyFields: false
      }
    }
  });
  if (typeof initialState !== 'undefined') {
    cache.restore(initialState);
  }
  return cache;
};